import { Fragment, ReactNode } from 'react';

/**
 * Renders a plain text string with \n turned into <br /> elements. Unlike
 * dangerouslySetInnerHTML, the text itself is never parsed as HTML, so
 * user provided content (e.g. tracker journal entries) cannot inject markup
 * (CH-3389).
 */
export function renderTextWithLineBreaks(text: string): ReactNode {
  return text.split('\n').map((line, index) => (
    // eslint-disable-next-line react/no-array-index-key
    <Fragment key={index}>
      {index > 0 && <br />}
      {line}
    </Fragment>
  ));
}
